export default __webpack_public_path__ + "media/images/fence-decor-572bc9f29a2f11809fd0aa68ef586f92.png";